<template>
  <el-dialog
      :visible.sync="visible"
      title="费用调整审核"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="90%"
  >
    <el-form
        :model="dataForm"
        ref="dataForm"
        label-width="120px"
    >
      <SweetTable ref="table" :data="dataForm.detailList" :is-page="false" :height="500" :selection="true">
        <el-table-column label="订单编号" prop="orderCode" align="center" width="180" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="品番号" align="center">
          <template #default="{row}">
            <ProductRowCard :product="row.product"></ProductRowCard>
          </template>
        </el-table-column>
        <el-table-column label="计划数" prop="planCount" align="center" width="100"></el-table-column>
        <el-table-column
            label="加工费"
            header-align="center"
            align="center"
            prop="amount"
            width="90"
        >
        </el-table-column>
        <el-table-column
            label="包装检品费"
            header-align="center"
            align="center"
            prop="checkAmount"
            width="100"
        >
        </el-table-column>
        <el-table-column label="纸箱" prop="packPrice" align="center" width="160">
          <template v-slot="scope">
            <div style="color: red;">
              <span>{{ scope.row.packPrice }}</span><span>→</span><span>{{ scope.row.auditParams.packPrice }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="中棉" prop="cottonPrice" align="center" width="160">
          <template v-slot="scope">
            <div style="color: red;">
              <span>{{ scope.row.cottonPrice }}</span><span>→</span><span>{{ scope.row.auditParams.cottonPrice }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="运费" prop="freightPrice" align="center" width="160">
          <template v-slot="scope">
            <div style="color: red;">
              <span>{{ scope.row.freightPrice }}</span><span>→</span><span>{{
                scope.row.auditParams.freightPrice
              }}</span>
            </div>
          </template>
        </el-table-column>
      </SweetTable>
    </el-form>
    <template slot="footer">
      <div style="display: flex;align-items: center;justify-content: space-between">
        <div></div>
        <div style="display: flex;">
          <el-button size="mini" @click="visible=false">{{ $t('cancel') }}</el-button>
          <el-button size="mini" type="warning" @click="doAudit('pass')">批量通过</el-button>
          <el-button size="mini" type="danger" @click="doAudit('reject')">批量驳回</el-button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { pass, reject } from '@/api/commonApi'
import ProductRowCard from '@/components/ProductRowCard.vue'

export default {
  components: { ProductRowCard },
  data () {
    return {
      visible: false,
      dataForm: {},
    }
  },
  methods: {
    init (detailList) {
      detailList.forEach((row) => {
        row.auditParams = JSON.parse(row.auditParams)
      })
      this.dataForm = {
        detailList: detailList,
      }
      this.visible = true
      this.$nextTick(() => {
        this.$refs.table.clearSelection()
        this.$refs.dataForm.clearValidate()
      })
    },
    async doAudit (type) {
      let selRows=this.$refs.table.dataListSelections
      if(selRows.length===0){
        return this.$message.error('请选择要操作的行')
      }

      await this.$confirm(`确定执行${type==='pass'?'通过':'驳回'}${selRows.length}条申请吗？`,'操作提示')
      let loading = this.$loading()
      let ids=selRows.map((row) => row.auditId)
      try {
        if(type==='pass'){
          await pass(ids)
        }else if(type==='reject'){
          await reject(ids)
        }
        this.$message.success('操作成功')
        this.visible = false
        this.$refs.table.clearSelection()
        this.$emit('change')
      } catch (e) {
        console.log(e)
      } finally {
        loading.close()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.dialog-content {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
